import "../../dashboard/DashboardLayout.css";
import { Autocomplete, Box, LoadingOverlay, Table } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";
import "../retailerAccess/retailerPayment.css";
import {
  getMetadata,
  getOnboardedStatus,
  getOutletDetails,
  updatePaymentEnableStatus,
} from "../../../services/bankingService";
import { useAuth } from "../../../providers/AuthProvider";
import {
  creditStatusType,
  outletList,
  outletListAPiResponse,
  PaymentBankProps,
  popupType,
} from "../../../types/types";
import { PaymentBank } from "../retailerAccess/paymentBank";
import { TableData } from "../retailerAccess/tableData";
import { GenericPopUp } from "../../popup/genericPopUp";
import { Heading } from "../heading/heading";
import { CircleX } from "tabler-icons-react";

export function RetailerPayment() {
  const [data, setData] = useState<outletListAPiResponse>({ features: [] });
  const [outletsWithPaymentEnabledState, setOutletsWithPaymentEnabledState] =
    useState<creditStatusType[]>([]);
  const [loaderShowOnCreateAccount, setLoaderShowOnCreateAccount] =
    useState<boolean>(false);
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState("");
  const [searched, setSearched] = useState("");
  const [rows, setRows] = useState<outletList[]>(data.features);
  const [bankList, setbankList] = useState<PaymentBankProps[]>([]);
  

  const authContext = useAuth();
  


  const fetchBankList = useCallback ( async () => {
    const metaDataResponse = await getMetadata();
    const bankListResponse = metaDataResponse.features.filter( (j:any) => (j.domainName === "clientconfig" && j.domainType === "bankListForPaymentBlocking"));  
    const domainBankList = bankListResponse[0].domainValues;
    setbankList(domainBankList);
    return domainBankList;
  },[authContext]);

  const getOutletList = useCallback(async () => {
    const loginid = JSON.parse(localStorage.authContext).user.loginId;
    const outlets = await getOutletDetails(loginid);
    setData(outlets)
    return outlets;
  }, [authContext]);

  const getOutletsWithOdAccess = useCallback(async () => {
    const loginid = JSON.parse(localStorage.authContext).user.loginId;
    const outletsOdAccess = await getOnboardedStatus(loginid);
    return outletsOdAccess;
  }, [authContext]);

  const odPaymentProvider = useCallback(async () => {
    const allStatusList = await getOutletsWithOdAccess();
    // console.log("allStatusList", allStatusList);
      const outletsWithStatusSuccess = allStatusList.features.filter(
        (successBank: { payment_enabled: string }) => successBank.payment_enabled === "YES"
      );
// console.log("outletsWithStatusSuccess",outletsWithStatusSuccess );

      setOutletsWithPaymentEnabledState(outletsWithStatusSuccess);
  },[getOutletsWithOdAccess]);

  useEffect(() => {
    const method = async () => {
      setLoaderShowOnCreateAccount(true);
      const resp = await getOutletList();
      setRows(resp?.features);
      const bankListHeader: PaymentBankProps = await fetchBankList();
      // console.log(bankListHeader);
      odPaymentProvider();
      setLoaderShowOnCreateAccount(false);
    };
    method();
  }, [getOutletList, odPaymentProvider ,fetchBankList]);

  const openPopup = (message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  };
  const searchList = [
    {
      id: 'outletcode',
      title: 'UID'
    },
    {
      id: 'district',
      title: 'District'
    },
    {
      id: 'branch',
      title: 'Branch'
    },
    {
      id: 'outlet_name',
      title: 'Outlet Name'
    },
  ]

  const requestSearch = (searchedVal: any, category: any) => {

    const filteredRows = data.features.filter((row) => {
      return row[category as keyof outletList].toLowerCase().indexOf(searchedVal.toLowerCase()) > -1;
    });
    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    setRows(data.features);
  };
  

  const submitForm = async (bankSelected: any, outletcode: string, id: string) => {
    setLoaderShowOnCreateAccount(true);
      const emptyArray: { userId: string; supplier: any; isEnabled: string; paymentEnabled: string; paymentProvideType: string; }[] = [];
      const paymentSubscriptionRequestBody = {
        userId: outletcode,
        supplier: JSON.parse(localStorage.authContext).user.loginId,
        paymentEnabled : "",
        paymentProvideType: ""
      };

      Object.keys(bankSelected).forEach((bank: any) => {
        let obj = JSON.parse(JSON.stringify(paymentSubscriptionRequestBody));
        obj.paymentEnabled = bankSelected[bank] ? "YES" : "NO";
        obj.paymentProvideType = bank;
        emptyArray.push(obj);
      });
      try{
       const ifPaymentEnabled = await updatePaymentEnableStatus(emptyArray);
       setLoaderShowOnCreateAccount(false);
       openPopup(ifPaymentEnabled.message, "Success");
      }catch(e:any){
        setLoaderShowOnCreateAccount(false);
        openPopup(e.response.data.message, "Error");
      }
       odPaymentProvider();
  };

  const searchData =
    searched.trim().length > 0 
      ? searchList.map((provider) => ({...provider, value: `${searched} in ${provider.title}`}))
      : [];

  
  return (
    <div className="app-container">
      {loaderShowOnCreateAccount && (
        <LoadingOverlay
          visible={loaderShowOnCreateAccount}
          style={{ position: "fixed" }}
        />
      )}

      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />

      <Autocomplete className="searchbar"
        value={searched}
        onChange={(value) => {
          if (value === "") setRows(data.features);
          setSearched(value)
        }}
        
        placeholder="Start typing to see options"
        data={searchData}
        onItemSubmit={(item) => {
          requestSearch(searched, item.id);
          setSearched(searched);
        }}
        rightSection={<CircleX size={20}
        strokeWidth={1}
        color={'grey'}
        onClick= {() => cancelSearch()}/>}
        
    />

      <Box className="mainBox">
        <Box className="headingAndTilesContainer">
          <Heading mainHeading="Retailer Payment Control" subHeading="Please select a payment method to enable payment"/>
          <Box className="tableRetailerPayment">
            <Table
              verticalSpacing="xs"
              fontSize="xs"
              horizontalSpacing={1}
              highlightOnHover
            >
              <thead>
                <tr>
                  <th>District</th>
                  <th>Branch</th>
                  <th>UID</th>
                  <th>Outlet Name</th>
                  {/* <th>Onboarded In</th> */}
                  {bankList.map((bank) => (
                    <th>
                      <PaymentBank
                        bankName={bank.bankName}
                        image={bank.image}
                        id={bank.id}
                      />
                    </th>
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows?.map((dat: outletList) => (
                  <TableData
                    banks={bankList}
                    dat={dat}
                    submitForm={submitForm}
                    bankNameSuccess = {outletsWithPaymentEnabledState?.filter((obj) => (obj.userId === dat.outletcode))}
                  />
                ))}
              </tbody>
            </Table>
          </Box>
        </Box>
      </Box>
      
    </div>
  );
}
